export default __webpack_public_path__ + "27befedab9fb693aeda97f6cd919e332.png";